import { graphql } from 'src/gql';

export const ViewerHouseholdsQuery = graphql(/* GraphQL */ `
  query ViewerHouseholds {
    currentUser {
      user {
        id
        activeHousehold {
          id
          name
        }
        memberHouseholds {
          id
          name
        }
      }
    }
  }
`);

export const SwitchActiveHouseholdMutation = graphql(/* GraphQL */ `
  mutation SwitchActiveHousehold($input: SwitchActiveHouseholdInput!) {
    switchActiveHousehold(input: $input) {
      user {
        id
        activeHousehold {
          id
          name
        }
      }
    }
  }
`);
